import SubscribeContextProvider from '../context/SubscribeContext';

export const withSubscribe = (component: () => React.ReactNode) => () =>
  <SubscribeContextProvider>{component()}</SubscribeContextProvider>;
